import i18n from "i18next";

export const defaultOrderListView = () => {
  return [
    { value: "Loads", label: i18n.t("userPreferences.byLoads") },
    { value: "Products", label: i18n.t("userPreferences.byProducts") }
  ];
};



// WEBPACK FOOTER //
// ./src/helpers/selectionViewHelpers.js